import React, { createContext, useContext, useState } from "react";
import {
  CreateButton,
  ResourceContextProvider,
} from "react-admin";
import { NodeActions, TreeWithDetails, DeleteMenuItemWithConfirmation } from "src/enterprise/ra-tree";
import { CategoryEdit } from "./CategoryEdit";
import { CategoryCreate } from "./CategoryCreate";
import { NodeActionsProps } from "src/enterprise/ra-tree/NodeActions";

export const CategoryContext = createContext({
  currentParent: null,
  setCurrentParent: null,
});

const CategoryActions = (props: NodeActionsProps) => {
  const { key, title } = props.data;

  return (
    <NodeActions {...props}>
      <DeleteMenuItemWithConfirmation confirmTitle={`Delete ${title} #${key}`}/>
    </NodeActions>
  );
};

export const CategoryList = props => {
  const [currentParent, setCurrentParent] = useState(null);

  return (
    <ResourceContextProvider value={`admin/product/categories`}>
      <CategoryContext.Provider
        value={{ currentParent, setCurrentParent }}
      >
        <TreeWithDetails
          edit={CategoryEdit}
          create={CategoryCreate}
          addRootButton={<AddRootButton />}
          titleField="name"
          allowMultipleRoots
          draggable
          nodeActions={<CategoryActions />}
        />
      </CategoryContext.Provider>
    </ResourceContextProvider>
  );
};

const AddRootButton = () => {
  const { setCurrentParent } = useContext(CategoryContext);

  return (
    <CreateButton
      label="ra-tree.action.add_root"
      onMouseUp={() => {
        setCurrentParent(null);
      }}
    />
  );
};

